export default "__VITE_ASSET__1fbdf647__"